// @flow
import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Icon from '../common/components/icon/Icon';
import { ICONS } from '../common/components/icon/Icons';
import PopupFooter from '../common/components/popup/PopupFooter';
import colors from '../common/components/ui/colors';
import withLocalized from '../localization/withLocalized';
import Interpolate from 'react-interpolate-component';

const StyledWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledContent = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  height: 100%;

  svg {
    margin: 0 auto 3rem;
  }

  h2 {
    font-size: 3.375rem;
    color: ${colors.BRAND_GREEN};
    text-transform: uppercase;
    margin-bottom: 1.5rem;
  }

  p {
    line-height: 1.2em;
    margin-bottom: 1em;
  }

  a {
    color: ${colors.BRAND_GREEN};
    cursor: pointer;
  }

`;

class BookingError extends Component {
  componentWillMount() {
    if(window.parent && window.self !== window.top) {
      window.parent.window.postMessage("BTPaymentRedirectEnd", "*");
    }
  }

  render() {
    const { localized } = this.props;
    const linkTarget = {
      pathname: `${this.props.linkRoot}/help`,
      state: {modal:true}
    };
   
    return (
      <StyledWrapper>
        <StyledContent>
          <img style={{
            width: "100%",
            height: "auto"
          }} src="/img/logo-gh.png" alt="Golfhubber" />
          <h2>{localized('booking.error.title')}</h2>
          <Interpolate
            with={{
              ask_help: <Link to={linkTarget}>{localized('booking.error.content_link')}</Link>
            }}
            format={localized('booking.error.content')}
            component='p'
          />
        </StyledContent>      
        <PopupFooter
          linkLabel={localized('booking.form.label_help')}
          linkTarget={linkTarget}
        />
      </StyledWrapper>
    );
  }
};

export default withLocalized(BookingError);



// WEBPACK FOOTER //
// ./src/modules/booking/BookingError.js